import styled from 'styled-components'
import Typography from '../../dumbs/Typography'
import DefaultClose from '../../svgs/Close'
import { StyledModalProps } from './interfaces'

const opacity = '80'

export const Background = styled.div`
  background-color: ${({ theme }) => theme.neutral.background.inverted + opacity};
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const Modal = styled.section<StyledModalProps>`
  background-color: ${({ theme }) => theme.neutral.background.default};
  width: ${({ $width }) => $width};
  border-radius: ${({ theme }) => theme.border.radius.large};
  padding: ${({ theme }) => theme.spacing.km6};
  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    margin: 16px;
  }
`

export const Close = styled(DefaultClose).attrs({ 'aria-label': 'close' })`
  cursor: pointer;
  margin-left: ${({ theme }) => theme.spacing.km6};
`

export const Title = styled(Typography).attrs({ as: 'h2' })`
  font-size: ${({ theme }) => theme.font.size.m5};
  flex: 1;
  letter-spacing: -0.03em;
`

export const Text = styled(Typography).attrs({ as: 'p' })`
  font-size: ${({ theme }) => theme.font.size.m3};
  line-height: ${({ theme }) => theme.font.lineHeight.large};
  color: ${({ theme }) => theme.neutral.text.default};
  letter-spacing: -0.02em;
`

export const SemiBoldText = styled(Text)`
  margin-top: ${({ theme }) => theme.spacing.km5};
  font-weight: ${({ theme }) => theme.font.weight.semibold};
`

export const Footer = styled.footer`
  display: flex;
  margin-top: ${({ theme }) => theme.spacing.km6};
  justify-content: flex-end;

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    flex-direction: column-reverse;
  }
`

export const Header = styled.header`
  display: flex;
  margin-bottom: ${({ theme }) => theme.spacing.km3};
`
